import { array, number, partial, record, string } from 'io-ts/Decoder';

import { Path, Point } from '../../../../../ui/geometry';
import { HexColor } from '../../../../../ui/HexColor';

export const Request = partial({
	name: string,
	color: HexColor,
	paths: array(Path),
	cutouts: array(Path),
	points: array(Point),
	// for future use when we want to update measurements of layers
	measurementValues: record(number),
});
